import { fileOpen } from "browser-fs-access";

import { useSchematicBuilderContext } from "../SchematicBuilderContext";

export function LoadSchematic() {
  const { name, setSchematic, latestSchematicFileHandle } =
    useSchematicBuilderContext();

  return (
    <button
      className="builder-icon-button builder-action builder-load-schematic"
      type="button"
      onClick={async () => {
        const file = await fileOpen({
          extensions: [".json"],
          mimeTypes: ["application/json"],
          description: "Form schematic",
          id: name,
        });
        if (file.handle) {
          latestSchematicFileHandle.current = file.handle;
        }
        const content = JSON.parse(await file.text());
        setSchematic(() => content);
      }}
      title="Load schematic"
    >
      📂
    </button>
  );
}
